import { render, staticRenderFns } from "./CatalogoWeb.vue?vue&type=template&id=5ea9c36c&scoped=true"
import script from "./CatalogoWeb.vue?vue&type=script&lang=js"
export * from "./CatalogoWeb.vue?vue&type=script&lang=js"
import style0 from "./CatalogoWeb.vue?vue&type=style&index=0&id=5ea9c36c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea9c36c",
  null
  
)

export default component.exports